import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import SubPageHeader from "./header-types/SubPageHeader";
import MainPageHeader from "./header-types/MainPageHeader";
import MinimalPageHeader from "./header-types/MinimalPageHeader";
import { MobilePlatform } from "@state/stores/types";
import MainPageSearchBarHeader from "./header-types/MainPageSearchHeader";
import SubPageSearchHeader from "./header-types/SubPageSearchHeader";
import CasinoMainPageSearchHeader from "./header-types/CasinoMainPageSearchHeader";
import CasinoSubPageSearchHeader from "./header-types/CasinoSubPageSearchHeader";

const Header = observer(() => {
	const rootStore = useRootAppStore<MobilePlatform>();

	const { headerType, title, backButton } = rootStore.pageStore;

	switch (headerType) {
		case "sub-page-with-search":
			return (
				<SubPageSearchHeader
					title={title}
					backButton={backButton || (() => history.back())}
				/>
			);
		case "main-page-with-search":
			return <MainPageSearchBarHeader />;
		case "sub-page":
			return (
				<SubPageHeader
					title={title}
					backButton={backButton || (() => history.back())}
				/>
			);
		case "minimal-page":
			return <MinimalPageHeader />;
		case "casino-main-page-with-search":
			return <CasinoMainPageSearchHeader />;
		case "casino-sub-page-with-search":
			return (
				<CasinoSubPageSearchHeader
					title={title}
					backButton={backButton || (() => history.back())}
				/>
			);
		case "main-page":
		default:
			return <MainPageHeader />;
	}
});
export default Header;
